export default __webpack_public_path__ + "static/media/m-fashion.1d73d1e0.svg";